// extracted by mini-css-extract-plugin
export default {"title":"title__Kzozd","alert":"alert__6Sz1w"};